var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mavon-editor',{attrs:{"external-link":_vm.externalLink,"toolbars":_vm.toolbars},on:{"change":_vm.changeCon},model:{value:(_vm.context),callback:function ($$v) {_vm.context=$$v},expression:"context"}})}
var staticRenderFns = []

export { render, staticRenderFns }